import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import { useReadyReaderProductData } from '../../../../../../../context/product-context-hooks.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@swc/helpers';
import '../../../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import { PackageQuantityDropdownContainer } from '../../../../../components/PackageQuantityDropdown/PackageQuantityDropdownContainer.js';
import '../../../../../../../hooks/use-product-view-history.js';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/content';
import { mapVariantsToPowerItems } from './utils/map-variants-to-power-items.js';

const ReadyReaderPowerSelector = ()=>{
    var ref;
    const { activeVariant , product  } = useReadyReaderProductData();
    const powerItems = mapVariantsToPowerItems(product.variants);
    const selectedPower = (ref = powerItems.find((item)=>item.value === activeVariant.sku
    )) === null || ref === void 0 ? void 0 : ref.value;
    const handleChange = (selectedValue)=>{
        DataLayer.pushEvent({
            event: 'readyreaders',
            eventAction: 'pdp select lens power',
            eventLabel: selectedValue.label
        });
    };
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdownContainer, {
        onChange: handleChange,
        selectedSize: selectedPower,
        items: powerItems
    });
};

export { ReadyReaderPowerSelector };
//# sourceMappingURL=ReadyReaderPowerSelector.js.map
